import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { cloneDeep, isEmpty } from 'lodash';
import moment from 'moment';
import PageTitle from '../../../../components/PageTitle';
import RouteNames from '../../../App/RouteNames';
import { uploadMultiPartFiles, saveOutputTemplateByType, getOutputTemplateByType } from '../../../App/actions';
import TitleFrom from '../../../../components/common/TitleFrom';
import { UsageReconciliationSearchForm } from '../../../../components/ReportHub';
import {
  SwitchExport,
  DataTable,
  ExcelExport,
  TablePagination,
  ButtonExport,
  EmailGroup,
  CollapsibleTable,
  DragDropConfigExportTemplate,
  ModalWithItem,
} from '../../../../components/common';
import {
  tabelColumnExportUsageReconciliation,
  sortUsageReconciliation,
  tabelColumnCdrFileStageStatsData,
} from '../../constants';
import { getFileProcessingStats, getAllFileProcessingStats, onResetDefaultData } from '../../actions';
import { makeGetListFileProcessingStats, makeGetListAllFileProcessingStats } from '../../selectors';
import {
  getPageTotalCount,
  parseToMutationRequestPostMethod,
  blobToFile,
  validateEmail,
  blobToCSVFile,
  configOutputTemplateByType,
} from '../../../../utils/utils';
import convertJson2Sheet from '../../../../utils/ExcelHelper/exportExcelFile';
import convertJson2Pdf from '../../../../utils/PdfHelper/exportPdfFile';
import { PAGE_SIZE_DOWNLOAD } from '../../../../utils/constants';

let tableColumnsOutput = null;

class UsageReconciliation extends Component {
  state = {
    isActivePdf: false,
    page: 0,
    size: 20,
    filter: {},
    sort: '',
    sorted: {},
    totalCount: null,
    isSearching: false,
    listUsageReconciliation: [],
    activeSubTab: {},
  };

  buttonRef = React.createRef();

  static getDerivedStateFromProps(props, state) {
    return {
      listUsageReconciliation: props.listUsageReconciliation,
      totalCount: getPageTotalCount({ ...state, items: props.listUsageReconciliation }),
    };
  }

  componentDidMount() {
    const {
      permissions: { modeGetUsageReconciliationReport },
      onResetDefaultData,
    } = this.props;
    if (modeGetUsageReconciliationReport) {
      this.doGetOutputTemplateByType();
      onResetDefaultData('listFileProcessingStats');
    }
  }

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => {
      this.doGetListUsageReconciliation();
    });
  };

  onPageChange = pageChange => {
    const { page } = this.state;
    if (page === pageChange) return '';
    return this.setState({ page: pageChange }, () => this.doGetListUsageReconciliation());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doGetListUsageReconciliation());
  };

  onHandleSubmitSearch = filter => {
    this.setState({ filter: { ...filter }, page: 0 }, () => {
      this.doGetListUsageReconciliation();
    });
  };

  doGetListUsageReconciliation = () => {
    const { filter, page, size, sorted } = this.state;
    const { getFileProcessingStats } = this.props;
    const newFilter = cloneDeep(filter);
    if (!newFilter.startDate) {
      newFilter.startDate = moment()
        .startOf('month')
        .format('YYYY-MM-DD HH:mm:ss');
    }
    if (!newFilter.endDate) {
      newFilter.endDate = moment()
        .endOf('month')
        .format('YYYY-MM-DD HH:mm:ss');
    }
    if (!newFilter.serviceType) {
      newFilter.serviceType = 'ALL';
    }
    const payload = {
      page: page + 1,
      size,
      filter: newFilter,
      sort:
        !isEmpty(sorted) && sortUsageReconciliation[sorted.sortCol]
          ? sortUsageReconciliation[sorted.sortCol][sorted.sortDir]
          : null,
    };
    this.setState({ isSearching: true });
    getFileProcessingStats(payload, () => {
      this.setState({ isSearching: false });
    });
  };

  doGetAlllistUsageReconciliation = cb => {
    const { filter, sorted } = this.state;
    const { getAllFileProcessingStats } = this.props;
    const newFilter = cloneDeep(filter);
    if (!newFilter.startDate) {
      newFilter.startDate = moment()
        .startOf('month')
        .format('YYYY-MM-DD HH:mm:ss');
    }
    if (!newFilter.endDate) {
      newFilter.endDate = moment()
        .endOf('month')
        .format('YYYY-MM-DD HH:mm:ss');
    }
    if (!newFilter.serviceType) {
      newFilter.serviceType = 'ALL';
    }
    const payload = {
      page: 1,
      size: PAGE_SIZE_DOWNLOAD,
      filter: newFilter,
      sort: !isEmpty(sorted) ? sortUsageReconciliation[sorted.sortCol][sorted.sortDir] : null,
    };
    getAllFileProcessingStats(payload, () => {
      if (cb) cb();
    });
  };

  onChangeSwitch = () => {
    const { isActivePdf } = this.state;
    this.setState({ isActivePdf: !isActivePdf });
  };

  onExport = () => {
    this.doGetAlllistUsageReconciliation(() => {
      const { isActivePdf } = this.state;
      if (isActivePdf) {
        const { listAllUsageReconciliation, t } = this.props;
        convertJson2Pdf({
          data: listAllUsageReconciliation,
          t,
          title: t('reportPage:sidebar.CDRReconciliationSummary').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.CDRReconciliationSummary')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          columnsTable: tableColumnsOutput,
          fontSize: 7,
        });
      } else {
        this.buttonRef.current.click();
      }
    });
  };

  sendEmail = ({ subject, emailBody }) => {
    this.doGetAlllistUsageReconciliation(() => {
      const { listAllUsageReconciliation, t, uploadMultiPartFiles } = this.props;
      const { emails, isActivePdf } = this.state;

      const query = `{"query": "mutation{sendReport(input: ${parseToMutationRequestPostMethod(
        {
          emailAddress: emails.join(', '),
          type: 'GET_USAGE_RECONCILIATION_REPORT',
          subject: subject || `Embrix Report ${t('reportPage:sidebar.CDRReconciliationSummary')}`,
          emailBody,
        },
        ['type']
      )})}"}`;
      const formData = new FormData();

      if (!isActivePdf) {
        formData.append(
          'file',
          blobToCSVFile({
            fileName: `${t('reportPage:sidebar.CDRReconciliationSummary')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}.csv`,
            data: listAllUsageReconciliation,
            t,
            columns: tableColumnsOutput,
          })
        );
      } else {
        const pdfFile = convertJson2Pdf({
          data: listAllUsageReconciliation,
          t,
          title: t('reportPage:sidebar.CDRReconciliationSummary').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.CDRReconciliationSummary')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          isFile: true,
          columnsTable: tableColumnsOutput,
          fontSize: 7,
        });
        formData.append(
          'file',
          blobToFile(
            pdfFile,
            `${t('reportPage:sidebar.CDRReconciliationSummary')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`
          )
        );
      }

      formData.append('graphql', query);
      // formData.append('file', blobToFile(pdfFile, 'attachment'));
      uploadMultiPartFiles(
        formData,
        res => {
          if (res && res.success) {
            if (res.success) this.setState({ emails: [] });
          }
        },
        true
      );
    });
  };

  onChangeEmail = tags => {
    let isEmail = true;
    if (tags && tags.length) {
      tags.forEach(email => {
        if (!validateEmail(email)) {
          isEmail = false;
        }
      });
    }
    if (!isEmail) return '';

    return this.setState({ emails: tags });
  };

  onToggleSubTab = (index, item, indexItem, key) => {
    const { activeSubTab } = this.state;
    if (activeSubTab.index === indexItem) this.setState({ activeSubTab: {} });
    if (activeSubTab.index !== indexItem) {
      // setActiveSubTab({ key, index: indexItem });
      // this.doGetOrderSummaryByAccountId(item.id);
      this.setState({
        activeSubTab: { key, index: indexItem },
      });
      // this.setState({ activeSegmentIndexTab: indexItem });
    }
  };

  doGetOutputTemplateByType = () => {
    const { getOutputTemplateByType, t } = this.props;
    getOutputTemplateByType('CDR_RECONCILIATION_SUMMARY_REPORT', ({ success, data }) => {
      if (success && data) {
        this.setState({
          exportColumnsSave: configOutputTemplateByType({
            columns: tabelColumnExportUsageReconciliation,
            data,
            t,
          }),
          idOutputTemplate: data?.id,
          typeOutputTemplate: data?.type,
        });
      }
    });
  };

  onHandleSaveConfig = columns => {
    const { saveOutputTemplateByType } = this.props;
    const { idOutputTemplate, typeOutputTemplate } = this.state;
    const payload = {
      id: idOutputTemplate,
      type: typeOutputTemplate,
      source: columns.sourceFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
      target: columns.targetFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
    };

    saveOutputTemplateByType(payload, ({ success }) => {
      if (success) {
        this.doGetOutputTemplateByType();
        this.setState({ exportColumnsSave: columns, isOpenModalExportConfig: false });
      }
    });
  };

  onToggleModalExportConfig = () => {
    const { isOpenModalExportConfig } = this.state;
    this.setState({ isOpenModalExportConfig: !isOpenModalExportConfig });
  };

  render() {
    const {
      isSearching,
      isActivePdf,
      sorted,
      page,
      size,
      totalCount,
      listUsageReconciliation,
      emails,
      activeSubTab,
      exportColumnsSave,
      isOpenModalExportConfig,
    } = this.state;
    const {
      listAllUsageReconciliation,
      t,
      permissions: { modeGetUsageReconciliationReport, modeDownloadReport, modeGetMailReport },
    } = this.props;
    if (!modeGetUsageReconciliationReport) return '';
    const exportColumns = exportColumnsSave || {};
    tableColumnsOutput = exportColumns?.targetFields?.items || [];

    const newTableColumns = [
      ...tableColumnsOutput,
      {
        name: 'exceptions',
        label: '',
        render: (colName, item, idx, indexParent, activeTab) => (
          <button type="button" className="btn-expand-table mr-3" onClick={evt => this.onToggleSubTab(idx, item, idx)}>
            <i className={`fa ${activeTab ? 'fa-minus' : 'fa-plus'}`} />
          </button>
        ),
      },
    ];
    return (
      <div className="col-md-12">
        <PageTitle
          linkTo={RouteNames.report.path}
          titleBtn="back"
          items={[
            { name: t('label.report'), url: RouteNames.report.path },
            { name: t('reportPage:sidebar.CDRReconciliationSummary') },
          ]}
        />
        <br />
        <div className="card card-statistics mb-30">
          <TitleFrom title={t('reportPage:sidebar.CDRReconciliationSummary')} />
          <div className="col-md-12 mb-30">
            <div className="card-body">
              <div className="pl-2">
                <UsageReconciliationSearchForm onSubmit={this.onHandleSubmitSearch} />
              </div>
              <div>
                <div className="mt-3 col-md-12 row mb-4 pt-3 pb-3">
                  <button
                    type="submit"
                    onClick={this.onToggleModalExportConfig}
                    className="button x-small mr-2 btn-config"
                  >
                    {/* {t('label.outputConfig')} */}
                    <i className="ti-list" />
                  </button>
                  {!!modeDownloadReport && (
                    <div className="ml-auto mt-2 mb-auto mr-3">
                      <SwitchExport
                        onChange={this.onChangeSwitch}
                        wrapperClass={isActivePdf ? 'switch-active' : 'switch-non-active'}
                        title={t('label.excel')}
                        checked={isActivePdf}
                        rightTitle={t('label.pdf')}
                      />
                    </div>
                  )}
                  {!!modeDownloadReport && (
                    <>
                      <ButtonExport onExport={this.onExport} />
                      <ExcelExport
                        element={<button type="button" className="display-none" ref={this.buttonRef} />}
                        nameSheet={t('reportPage:sidebar.CDRReconciliationSummary').toLocaleUpperCase()}
                        multiDataSet={convertJson2Sheet({
                          data: listAllUsageReconciliation,
                          t,
                          title: t('reportPage:sidebar.CDRReconciliationSummary').toLocaleUpperCase(),
                          columnsTable: tableColumnsOutput,
                        })}
                        fileName={`${t('reportPage:sidebar.CDRReconciliationSummary')
                          .toLocaleLowerCase()
                          .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`}
                      />
                    </>
                  )}
                  {modeGetMailReport !== 0 && (
                    <EmailGroup
                      emails={emails}
                      onChangeEmail={this.onChangeEmail}
                      sendEmail={this.sendEmail}
                      data={listUsageReconciliation}
                    />
                  )}
                </div>
                {/* <DataTable
                  columns={tabelColumnExportUsageReconciliation}
                  data={listUsageReconciliation && listUsageReconciliation.length ? listUsageReconciliation : []}
                  onSort={this.onSortColumn}
                  sorted={sorted}
                  isLoading={isSearching}
                  isFixedHeaderTable
                /> */}
                <div className="group-collapsible">
                  <CollapsibleTable
                    indexViewer={activeSubTab && activeSubTab.index !== -1 ? activeSubTab.index : -1}
                    columns={newTableColumns}
                    data={listUsageReconciliation && listUsageReconciliation.length ? listUsageReconciliation : []}
                    isLoading={isSearching}
                    onSort={this.onSortColumn}
                    isViewOnly
                    isFixedHeaderTable
                    sorted={sorted}
                  >
                    <DataTable
                      columns={tabelColumnCdrFileStageStatsData}
                      data={
                        listUsageReconciliation &&
                        listUsageReconciliation.length &&
                        activeSubTab.index !== -1 &&
                        listUsageReconciliation[activeSubTab.index] &&
                        listUsageReconciliation[activeSubTab.index].cdrFileStageStatsData
                          ? listUsageReconciliation[activeSubTab.index].cdrFileStageStatsData
                          : []
                      }
                    />
                  </CollapsibleTable>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mb-30">
          <TablePagination
            pageNumber={page}
            pageSize={size}
            totalCount={totalCount}
            onPageChange={this.onPageChange}
            onSizeChange={this.onSizeChange}
          />
        </div>
        <ModalWithItem
          onToggle={this.onToggleModalExportConfig}
          isOpen={isOpenModalExportConfig}
          wrapperClass="modal-config"
        >
          <div className="col-md-12 d-flex">
            <div className="column-config" onClick={this.onToggleModalExportConfig} />
            <div className="body-config">
              <DragDropConfigExportTemplate
                onHandleSave={this.onHandleSaveConfig}
                exportColumns={exportColumns}
                onToggle={this.onToggleModalExportConfig}
              />
            </div>
          </div>
        </ModalWithItem>
      </div>
    );
  }
}

UsageReconciliation.propTypes = {
  getFileProcessingStats: PropTypes.func,
  getAllFileProcessingStats: PropTypes.func,
  listAllUsageReconciliation: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.any),
    PropTypes.objectOf(PropTypes.any),
  ]),
};

UsageReconciliation.defaultProps = {
  getFileProcessingStats: () => {},
  getAllFileProcessingStats: () => {},
  listAllUsageReconciliation: [],
};

const mapStateToProps = createStructuredSelector({
  listUsageReconciliation: makeGetListFileProcessingStats() || [],
  listAllUsageReconciliation: makeGetListAllFileProcessingStats() || [],
});
export default withTranslation('common')(
  connect(mapStateToProps, {
    getFileProcessingStats,
    getAllFileProcessingStats,
    uploadMultiPartFiles,
    saveOutputTemplateByType,
    getOutputTemplateByType,
    onResetDefaultData,
  })(UsageReconciliation)
);
